import React from "react";
import models from "../../types/models";
import BaseIcon from "../BaseIcon";
import "./style.scss";
import PropTypes from "prop-types";

export default function BaseSpinner({ type = "light", className }) {
  BaseSpinner.propTypes = {
    type: models.typeSpinner,
    className: PropTypes.string,
  };
  return (
    <BaseIcon
      name="spinner"
      className={["spinner", `spinner_${type}`, className].join(" ")}
    />
  );
}
